import { palette } from '@/modules/defines/styles';
import styled, { keyframes } from 'styled-components';
import { memo } from 'react';
interface MarkerProps {
  $left: string;
  $top: string;
  $translateX: string;
  $translateY: string;
}

interface NavigationMarkerProps {
  left: string;
  top: string;
  translateX: string;
  translateY: string;
}

const NavigationMarker = ({
  left,
  top,
  translateX,
  translateY,
}: NavigationMarkerProps) => {
  return (
    <SvgContainer
      $left={left}
      $top={top}
      $translateX={translateX}
      $translateY={translateY}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <OuterRect />
      <InnerRect />
    </SvgContainer>
  );
};

const pulse = keyframes`
  0% {
    transform: scale(0.9);
    opacity: 1;
  }
  50% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    transform: scale(0.9);
    opacity: 1;
  }
`;

const SvgContainer = styled.svg<MarkerProps>`
  width: 24px;
  height: 24px;
  position: absolute;
  z-index: 22;
  left: ${(props) => props.$left};
  top: ${(props) => props.$top};
  transform: translate(
    ${(props) => props.$translateX},
    ${(props) => props.$translateY}
  );
`;

const OuterRect = styled.rect`
  width: 24px;
  height: 24px;
  rx: 12;
  fill: ${palette.primaryRed500};
  fill-opacity: 0.3;
  transform-origin: center;
  animation: ${pulse} 1.5s infinite;
`;

const InnerRect = styled.rect`
  x: 6px;
  y: 6px;
  width: 12px;
  height: 12px;
  rx: 6;
  fill: ${palette.primaryRed500};
`;

export default memo(NavigationMarker);
